<div class="container-fluid">
	<div class="col-md-12" *ngIf="isLoading">
		<app-busy [message]="message"></app-busy>
	</div>
	<div class="page_header">
		<h1 class="heading"><i class="fa fa-cogs"></i> 
			Manage {{this.lblHeading}}
		</h1>
	</div>
	<ng-template #content let-modal>
		<div class="modal-header">
			<h4 class="modal-title" id="modal-basic-title"> Delete Confirmation</h4>
			<button type="button" class="btn-close" aria-label="Close"
				(click)="modal.dismiss('Cross click')">&times;</button>
		</div>
		<div class="modal-body">
			<input type="hidden" [(ngModel)]="removeRef" name="id" /> <span [innerHTML]="deleteConfirm"></span>
		</div>
		<div class="modal-footer">
			<button class="btn btn-danger btn-sm" (click)="onDelete(removeRef.id)" style="width:80px;">Yes</button>
			<button class="btn btn-default btn-sm" (click)="modal.dismiss('Cross click')"
				style="width:80px;">No</button>
		</div>
	</ng-template>
	<div class="row">
		<!-- <div *ngIf="isRemove" class="text-danger col-md-12">


      <input type="hidden" [(ngModel)]="removeRef" name="id" /> <span [innerHTML]="deleteConfirm"></span>
      <button class="btn btn-danger btn-sm" (click)="onDelete(removeRef.id)" style="width:80px;">Yes</button>
      <button class="btn btn-default btn-sm" (click)="onNo()" style="width:80px;">No</button>
    </div> -->

		<div class="col-md-12" *ngIf="!isRemove">
			<div>
				<app-actions (actionEvent)="doCarrierAction($event)"
					[selectcarriertype]="selectcarriertype"></app-actions>
			</div>
			<div class="table-responsive">
				<table id="vTypes" border="1" class="table tbl-stl custom_table">
					<thead class="thead-inverse hgt-btn">
						<tr class="hgt-btn">
							<th>Select</th>
							<th class="bfr-end-col">
								Code
								<i class="fa"
									[ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagCE == 2),'fa-sort-desc sort-d': (utility.flags.flagCE == 3), 'fa-sort':(utility.flags.flagCE == 1) }"
									(click)="utility.onSort(1)"></i>
							</th>
							<th class="bfr-end-col">
								Description
								<i style="vertical-align:middle;" class="fa"
									[ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagDN == 2),'fa-sort-desc sort-d': (utility.flags.flagDN == 3), 'fa-sort':(utility.flags.flagDN == 1) }"
									(click)="utility.onSort(2)"></i>
							</th>
							<th class="bfr-end-col">
								Active?
								<i style="vertical-align:middle;" class="fa"
									[ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagAE == 2),'fa-sort-desc sort-d': (utility.flags.flagAE == 3), 'fa-sort':(utility.flags.flagAE == 1) }"
									(click)="utility.onSort(3)"></i>
							</th>
							<th class="bfr-end-col">
								Sort Order
								<i style="vertical-align:middle;" class="fa"
									[ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagSO == 2),'fa-sort-desc sort-d': (utility.flags.flagSO == 3), 'fa-sort':(utility.flags.flagSO == 1) }"
									(click)="utility.onSort(5)"></i>
							</th>
							<th class="bfr-end-col">
								Group
								<i style="vertical-align:middle;" class="fa"
									[ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagGC == 2),'fa-sort-desc sort-d': (utility.flags.flagGC == 3), 'fa-sort':(utility.flags.flagGC == 1) }"
									(click)="utility.onSort(4)"></i>
							</th>
							<th class="bfr-end-col">Display?</th>
							<!-- <th style="vertical-align:middle;padding:0px;" class="bfr-end-col">Actions</th> -->
						</tr>
					</thead>
					<tr 
						*ngFor="let cType of cTypes  | orderBy:utility.criteria : utility.direction | paginate: { itemsPerPage: showNum, currentPage: utility.page };let index = index">
						<td><input type="checkbox" value="{{cType.id}}" [ngModel]="selectedIndex === index"
								(change)="CheckedCarrier($event,cType.id,cType,index)"></td>
						<td class="bfr-end-col">{{cType.code}}</td>
						<td class="bfr-end-col">{{cType.description}}</td>
						<td class="bfr-end-col">{{utility.isActive(cType.is_active)}}</td>
						<td class="bfr-end-col">{{cType.sort_order}}</td>
						<td class="bfr-end-col">{{cType.group_code}}</td>
						<td class="bfr-end-col">{{utility.showDisplayIndicator(cType.display_ind)}}</td>
					</tr>
					<tfoot>
						<tr *ngIf="cTypes.length > 4" class="pagination_row">
							<td colspan="12" class="rm-brd">
								<div class="row">
									<div class="col-6">
										<div class="input-group mb-3 rm-brd"
											style="width:125px!important;height:30px!important;">
											<div class="input-group-prepend">
												<label class="input-group-text form-control-sm show-h"
													for="show-id">Show:</label>
											</div>
											<select class="form-control form-control-sm show-h" id="show-id"
												[(ngModel)]="showNum">
												<option *ngFor="let key of utility.pageItems" [ngValue]="key">{{key}}
												</option>
											</select>
										</div>
									</div>
									<div class="col-6 text-right">
										<pagination-controls (pageChange)="utility.page = $event"></pagination-controls>
									</div>
								</div>
							</td>
						</tr>
						<tr *ngIf="isEmpty">
							<td colspan="4" class="rm-brd">
								<span class="text-info text-small">No Carrier Types found.</span>
							</td>
						</tr>
					</tfoot>
				</table>
			</div>
		</div>
	</div>
</div>